import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=62cd22d2"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"
import style0 from "./Forget.vue?vue&type=style&index=0&id=62cd22d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports